/**
 * Burger Navigation Component
 *
 * Handles toggle functionality for burger menu with accessibility support.
 */

class BurgerNav {
  constructor(element) {
    this.nav = element;
    this.toggleBtn = element.querySelector(".burger-nav__toggle");
    this.menu = element.querySelector(".burger-nav__menu");

    if (!this.toggleBtn || !this.menu) {
      console.warn("BurgerNav: Missing required elements");
      return;
    }

    this.isOpen = this.toggleBtn.getAttribute("aria-expanded") === "true";
    this.bindEvents();
  }

  bindEvents() {
    // Toggle button click
    this.toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggle();
    });

    // Close on Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
        this.toggleBtn.focus();
      }
    });

    // Close on click outside
    document.addEventListener("click", (e) => {
      if (this.isOpen && !this.nav.contains(e.target)) {
        this.close();
      }
    });

    // Handle menu item clicks (close menu after navigation)
    this.menu.addEventListener("click", (e) => {
      const menuItem = e.target.closest(".burger-nav__item");
      if (menuItem) {
        // Allow the link to work, then close menu
        setTimeout(() => this.close(), 100);
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.toggleBtn.setAttribute("aria-expanded", "true");
    this.menu.setAttribute("data-open", "true");

    // Update screen reader text
    const srText = this.toggleBtn.querySelector(".sr-only");
    if (srText) {
      srText.textContent = "Close menu";
    }

    // Focus the menu container itself (no visible ring; first user Tab moves into items)
    setTimeout(() => this.menu.focus({ preventScroll: true }), 100);
  }

  close() {
    this.isOpen = false;
    this.toggleBtn.setAttribute("aria-expanded", "false");
    this.menu.setAttribute("data-open", "false");

    // Update screen reader text
    const srText = this.toggleBtn.querySelector(".sr-only");
    if (srText) {
      srText.textContent = "Open menu";
    }
  }
}

/**
 * Initialize all burger navigation instances
 */
function initBurgerNav() {
  const navElements = document.querySelectorAll(".burger-nav");
  navElements.forEach((el) => new BurgerNav(el));
}

export { BurgerNav, initBurgerNav };
export default initBurgerNav;
